import React from 'react'
import styled from 'react-emotion'
import User from 'common/components/User'
import Text from 'common/components/Text'
import Toolbar from '../../common/Toolbar'
import { StyledButton as Button } from '../../common/Button'
import { border, space, color } from '../../../style'
import CommentInput from '../CommentInput'
import Linkify from 'react-linkify'

const CommentActions = styled('div')({
  display: 'flex',
  paddingTop: space.default,
  [`${Text}:not(:last-child)`]: {
    marginRight: space.small
  }
})
const Actions = styled('div')({
  display: 'flex',
  paddingTop: space.default,
  paddingBottom: space.small,
  [`${Button}:not(:last-child)`]: {
    marginRight: space.default
  }
})

const Comment = styled(
  ({
    comment,
    preview,
    userId,
    remove,
    edit,
    editedText,
    setEditedText,
    saveEdit,
    cancelEdit,
    Shortcuts,
    className,
    t
  }) =>
    !comment.dateDeleted ? (
      <div className={className}>
        <User small userId={comment.userId} />

        {editedText === null ? (
          <>
            <Text multiline className="commentText">
              <Linkify
                properties={{ target: '_blank', rel: 'noopener noreferrer' }}
              >
                {comment.text}
              </Linkify>
            </Text>

            <CommentActions>
              {/* Date */}
              <Text grey small title={t('fullDate', { date: comment.date })}>
                {t('date', { date: comment.date })}
              </Text>

              <Toolbar.Spacer />

              {/* Edit / Delete */}
              {preview ? (
                <Text small grey>
                  {t('discuss.comment.replyCount', { count: preview.replies })}
                </Text>
              ) : (
                userId === comment.userId && (
                  <>
                    <Text small bold grey onClick={edit}>
                      {t('discuss.comment.edit')}
                    </Text>
                    <Text small bold grey onClick={remove}>
                      {t('discuss.comment.delete')}
                    </Text>
                  </>
                )
              )}
            </CommentActions>
          </>
        ) : (
          // Editing
          <>
            <CommentInput
              autoFocus
              value={editedText}
              onChange={e => setEditedText(e.target.value)}
            />

            <Actions>
              <Toolbar.Spacer />
              <Button rounded onClick={cancelEdit}>
                {t('discuss.comment.cancel')}
              </Button>
              <Button rounded primary onClick={saveEdit}>
                {t('discuss.comment.doneEdit')}
              </Button>
            </Actions>

            <Shortcuts />
          </>
        )}
      </div>
    ) : (
      <div className={className}>
        <User small userId={comment.userId} />
        <Text grey className="commentText">
          {t('discuss.comment.isDeleted')}
        </Text>
      </div>
    )
)(({ preview }) => ({
  label: 'Comment',
  padding: space.default,
  '&:not(:last-child)': {
    borderBottom: border
  },
  [User.className]: {
    marginBottom: space.default
  },
  '.commentText': {
    display: 'block',
    marginBottom: space.small,
    whiteSpace: preview ? 'nowrap' : 'pre-line',
    wordBreak: 'break-word',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    a: {
      color: color.black
    }
  }
}))

export default Comment
